import React, { useState, useRef } from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'

import FeatureDetail from '../../../FeatureDetail'

import classes from './ExpandableFeaturesList.module.scss'

const COLLAPSED_LENGTH = 9

/** @type {import("./types").default} */
const ExpandableFeaturesList = ({ title, search, features }) => {
  const container = useRef()

  const { addEvent } = useEventContext()

  const [expanded, setExpanded] = useState(false)
  const listVisible = features.slice(0, COLLAPSED_LENGTH)
  const rest = features.slice(COLLAPSED_LENGTH)

  const isExpandable = features.length > COLLAPSED_LENGTH && !search

  if (!features?.length) {
    return null
  }

  return (
    <div className={clsx('ExpandableFeaturesList', classes.root)} ref={container}>
      <p className={classes.title}>{title}</p>
      <div className={classes.featuresCont}>
        {listVisible.map(feature => (
          <FeatureDetail key={feature.slug} feature={feature} />
        ))}
        {rest.map(feature => (
          <FeatureDetail
            className={clsx({ [classes.featureHidden]: !expanded })}
            key={feature.slug}
            feature={feature}
          />
        ))}
      </div>
      {isExpandable && (
        <div className={classes.buttonCont}>
          <Button
            onClick={() => setExpanded(!expanded)}
            className={classes.expandButton}
            data-testid="expand-button"
            {...addEvent({
              name: 'engagement_product_click',
              engagementComponent: 'product_key-features',
              engagementDestination: expanded ? 'collapse_features-list' : 'expand_features-list',
              engagementDetails: expanded ? 'text-link_see-less-features' : 'text-link_see-all-features',
            })}
          >
            {!expanded ? 'Expand list' : 'Collapse list'}
            <Icon icon={['far', `chevron-${expanded ? 'up' : 'down'}`]} size={16} />
          </Button>
        </div>
      )}
    </div>
  )
}

export default ExpandableFeaturesList
